<template>
  <div class="formSelectAmount">
    <button type="button" class="btMinus" @click="decreseQuantity()">
      <span class="icon iconMinus"></span>
    </button>
    <!-- <input type="text" class="inputAmount" :value="quantity" @focus="$event.target.select()" @input="handleInput($event)"> -->
    <div class="inputAmount">{{ quantity }}</div>
    <button type="button" class="btPlus" @click="increseQuantity()">
      <span class="icon iconPlus"></span>
    </button>
  </div>
</template>
∂
<script>
export default {
  props: {
    quantity: {
      type: Number,
      default: 1
    }
  },
  methods: {
    increseQuantity() {
      this.$emit('handleQuantity', 1)
    },
    decreseQuantity() {
      this.$emit('handleQuantity', -1)
    }
    /*,
    handleInput(e) {
      let value = Number(e.target.value.replace(/\D+/g, ''))
      if (value < 1) value = 1
      this.$emit('handleQuantity', value, true)

      // 제한에 걸려 갱신에 실패할 경우를 대비하여 quantity 값을 재할당 해준다.
      e.target.value = this.quantity
    }
    */
  }
}
</script>

<style lang="scss" scoped>
.formSelectAmount {
  vertical-align: top;
  .btMinus,
  .btPlus {
    width: 31px;
    height: 31px;
    padding-bottom: 2px;
    border: 1px solid #d6d6db;
    vertical-align: top;
  }
  .inputAmount {
    display: inline-block; /* yongwkan 추가 */
    line-height: 29px; /* yongwkan 추가 */
    width: 45px;
    height: 31px;
    padding-top: 2px;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    border-top: 1px solid #d6d6db;
    border-bottom: 1px solid #d6d6db;
    vertical-align: top;
  }
}
</style>
